import { Avatar, Box, Flex } from "@chakra-ui/react";
import PopoverTagColumn from "components/Column/PopoverTagDisplay";
import { PlusNTag } from "components/Tag/PlusNTag";
import RecipientTag from "components/Tag/ResourceTargetTag/RecipientTag";
import { Task } from "features/Resources/Task/models";
import { useUserDetailQuery } from "features/User/hooks";
import { User } from "features/User/models";
import useTargetName from "hooks/useTargetName";

function AssigneeTag({ assignee }: { assignee: User; }) {
  return (
    <RecipientTag
      key={assignee.id}
      resourceId={assignee.id}
      resourceType="User"
      disabled
    />
  );
}

function AssigneeAvatar({ assignee }: { assignee: User }) {
  if (!assignee) return null;

  return (
    <Box position="relative">
      <Avatar
        size="sm"
        name={assignee?.fullName || ""}
        src={assignee?.avatarUrl}
        // bgColor={bgColor}
        color="gray.500"
        showBorder={true}
        borderColor={"disabledGray.DEFAULT"}
        borderWidth="1px"
      />
      {/**/}
      {/* {isLeader && ( */}
      {/*   <Box */}
      {/*     position="absolute" */}
      {/*     top="-6px" */}
      {/*     left="50%" */}
      {/*     transform="translateX(-50%)" */}
      {/*   > */}
      {/*     <LeadAvatarIndicator /> */}
      {/*   </Box> */}
      {/* )} */}
    </Box>
  );
}

export function DisplayAssigneeColumn({ task }: { task: Task }) {
  const { data: assignee, isPending } = useUserDetailQuery(task?.assigneeId, { enabled: !!task?.assigneeId });

  if (!task?.assigneeId) return null;
  if (isPending) return "Loading..."
  if (!assignee) return "TBD"

  const maxAvatarCount = 3;
  return (
    <Flex align="center" gap="1">
      <PopoverTagColumn<User>
        items={[assignee]}
        renderTag={(u) => <AssigneeTag assignee={u} />}
        displaySummary={(items: User[]) => (
          <Flex align="center" mx="2" flexDirection="row-reverse">
            <PlusNTag
              maxCount={maxAvatarCount}
              items={items}
              ml="-6px"
              size="33px"
            />
            {items.slice(0, maxAvatarCount).reverse().map((assignee) => (
              <Box key={assignee.id} ml="-6px">
                <AssigneeAvatar assignee={assignee} />
              </Box>
            ))}
          </Flex>
        )}
        emptyLabel="No Recipients"
        popoverContainerContentProps={{ marginTop: "1" }}
      />
    </Flex>
  );
}

export function DisplayAssignee({ task }: { task: Task }) {
  const { data: assignee, isPending } = useUserDetailQuery(task?.assigneeId, { enabled: !!task?.assigneeId });

  if (!task?.assigneeId) return null;
  if (isPending) return "Loading..."
  if (!assignee) return ""

  return (
    <Flex align="center" gap="1">
      <AssigneeTag assignee={task.assignee} />
    </Flex>
  );
}

export function DisplayAssigneeValue({ task }: { task: Task }) {
  const { name } = useTargetName({ resourceId: task?.assigneeId, resourceType: "User" });
  return name;
}
